import styled from 'styled-components';

export const SubDimensionWrapper = styled.div`
  width: 100%;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #c7cccf;
  margin-top: 0.5rem;
  &&:last-of-type {
    border-bottom: 0px none;
  }
`;

export const SubDimensionName = styled.div<{ isMobile: boolean }>`
  ${({ isMobile }) => isMobile && 'padding: 0 1rem;'}
`;
